var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSendRegularBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#660099;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "S\\xE1bana-de-iconos-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.513 2.831c.005-.038.005-.076.005-.109v-.024a.722.722 0 00-.023-.137v-.01a.058.058 0 01-.009-.028.514.514 0 00-.054-.137l-.04-.071a.717.717 0 00-.086-.104l-.019-.017a1.046 1.046 0 00-.104-.083.704.704 0 00-.212-.09c-.004-.003-.01-.004-.015-.005a.558.558 0 00-.235-.007.12.12 0 01-.02.002.326.326 0 01-.035.005c-.01.001-.022.002-.033.005L2.99 7.03a.737.737 0 00-.519.654.75.75 0 00.406.734l7.898 3.815-.696.73a.767.767 0 000 1.047c.276.29.723.29.998 0l.696-.73 3.634 8.289a.703.703 0 00.642.431c.018 0 .04 0 .058-.005a.708.708 0 00.623-.545l4.764-18.51.005-.028c0-.01.002-.02.004-.029l.002-.01a.142.142 0 00.007-.042zm-3.066 1.35l-6.606 6.934-6.601-3.19 13.207-3.743zm-5.608 7.981l6.606-6.933-3.567 13.861-3.039-6.928z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendRegularBlue);
export default __webpack_public_path__ + "static/media/icon-send-regular-blue.459d10df38c608ffbbc2d001ecf5d017.svg";
export { ForwardRef as ReactComponent };